/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { KTSVG, toAbsoluteUrl } from '../../helpers'
import { LanguageHelp } from '../../helpers/LanguageHelper'

type Props = {
    rate: number
    reversed?: boolean
}

const Rating: React.FC<Props> = ({ rate = 0, reversed = false }) => {
    return (
        <div style={{ display: 'unset' }}>
            {(rate > 0 && reversed === false) &&
                <span className='badge badge-light-success fw-bolder'>
                    <KTSVG
                        path='/media/icons/duotune/arrows/arr066.svg'
                        className='svg-icon-5 svg-icon-success ms-n1'
                    />{' '}
                    {rate}%
                </span>
            }
            {(rate > 0 && reversed === true) &&
                <span className='badge badge-light-danger fw-bolder'>
                    <KTSVG
                        path='/media/icons/duotune/arrows/arr066.svg'
                        className='svg-icon-5 svg-icon-danger ms-n1'
                    />{' '}
                    {rate}%
                </span>
            }
            {(rate < 0 && reversed === false) &&
                <span className='badge badge-light-danger fw-bolder'>
                    <KTSVG
                        path='/media/icons/duotune/arrows/arr065.svg'
                        className='svg-icon-5 svg-icon-danger ms-n1'
                    />{' '}
                    {rate}%
                </span>
            }
            {(rate < 0 && reversed === true) &&
                <span className='badge badge-light-success fw-bolder'>
                    <KTSVG
                        path='/media/icons/duotune/arrows/arr065.svg'
                        className='svg-icon-5 svg-icon-success ms-n1'
                    />{' '}
                    {rate}%
                </span>
            }
        </div>
    )
}

export { Rating }
